import { Text } from '../../../../shared-components';
import { Masonry } from '../../../../shared-components/masonry/Masonry';
import { getProductPremium } from '../../../brite-viewer/components/benefits/field-utils';
import { getTiersAndLabels } from '../../../brite-viewer/components/benefits/plan-comparisons/use-display-settings';
import { useStore } from '../../../store-provider/use-store';

export const CostGroup = (props) => {
  const {
    data: { displaySettings },
  } = useStore();

  const { data } = props;

  const premiumsSetExternally = data?.product?.Details?.PlanType?.startsWith('aca');
  const { product } = data;
  const cost = product?.Cost;
  const { tiers, tierLabels } = getTiersAndLabels({
    cost,
    displaySettings,
  });

  const title = `Cost ${displaySettings?.premiumInterval === 12 ? 'per month' : 'per pay period'}`;

  return (
    <Masonry.Group>
      <Masonry.Group.Title value={title} />
      <Masonry.Group.Content>
        {tiers?.map((key, idx) => (
          <Masonry.Group.Item>
            <Text label>{tierLabels?.[idx]}</Text>
            <Text label bold>
              {getProductPremium({
                cost,
                key,
                interval: displaySettings?.premiumInterval,
              })}
            </Text>
          </Masonry.Group.Item>
        ))}
      </Masonry.Group.Content>
    </Masonry.Group>
  );
};
